import React from 'react';

import { generalCategoryContactList as assignToList } from 'constants/automationConstants';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { MultiSelect } from 'primereact/multiselect';
import { InputText } from 'primereact/inputtext';
import { Controller, useFormContext } from 'react-hook-form';

import { templateFormatOptions } from 'constants/automation';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import { FormLabel, TrackTime } from 'modules/automation/WorkflowBuilder/components';
import { displayActionCardHeader } from 'modules/automation/utils/displayActionCardHeader';
import { useTemplatesList } from 'hooks/useTemplatesList';

const CreateDocument = ({ index }) => {
  const {
    control,
    formState: { errors },
    setValue,
    watch,
  } = useFormContext();

  const { templateListOptions, loading } = useTemplatesList();

  const sendMail = watch(`actions[${index}].send_mail`);

  return (
    <>
      {displayActionCardHeader('Configure Document creation action')}

      <div className="row g-3 mb-2">
        <div className="col-12 col-lg-6">
          <FormLabel label="Template" isRequired />
          <Controller
            name={`actions[${index}].template`}
            control={control}
            rules={{ required: 'Please select a template' }}
            render={({ field: { name, value, onChange, ref } }) => (
              <Dropdown
                name={name}
                value={value}
                options={templateListOptions || []}
                onChange={(e) => onChange(e.value)}
                className="w-100 input-shadow"
                placeholder="Select Template"
                optionLabel="label"
                dropdownIcon={loading ? 'pi pi-spin pi-spinner' : null}
                inputRef={ref}
              />
            )}
          />
          <RequiredValidation errors={errors} field={`actions.${index}.template`} />
        </div>

        <div className="col-12 col-lg-6">
          <FormLabel label="Document Name" isRequired />
          <Controller
            name={`actions[${index}].document_name`}
            control={control}
            rules={{ required: 'Document is required' }}
            render={({ field: { name, value, onChange } }) => (
              <InputText
                name={name}
                value={value || ''}
                onChange={(e) => onChange(e)}
                className="w-100 input-shadow"
                placeholder="Document Name"
              />
            )}
          />
          <RequiredValidation errors={errors} field={`actions.${index}.document_name`} />
        </div>

        <div className="col-12 col-lg-6">
          <FormLabel label="Select Document Format" isRequired />
          <Controller
            name={`actions[${index}].document_format`}
            control={control}
            rules={{ required: 'Document Format is required' }}
            render={({ field: { name, value, onChange, ref } }) => (
              <Dropdown
                name={name}
                value={value}
                options={templateFormatOptions}
                onChange={(e) => onChange(e)}
                className="w-100 input-shadow"
                placeholder="Select Document Format"
                optionLabel="label"
                inputRef={ref}
              />
            )}
          />
          <RequiredValidation errors={errors} field={`actions.${index}.document_format`} />
        </div>

        <div className="col-12 col-lg-6">
          <FormLabel label="Share Document" isRequired={false} />
          <Controller
            name={`actions[${index}].send_mail`}
            control={control}
            render={({ field: { value, onChange } }) => (
              <InputSwitch
                checked={value}
                onChange={(e) => {
                  if (!e.value) {
                    setValue(`actions[${index}].contact_assignees`, []);
                  }
                  onChange(e.value);
                }}
              />
            )}
          />
        </div>

        {sendMail && (
          <div className="col-12 col-lg-6">
            <FormLabel label="Select Contact" isRequired />
            <Controller
              name={`actions[${index}].contact_assignees`}
              control={control}
              rules={{ required: 'Assignees are required' }}
              render={({ field: { name, value, onChange } }) => (
                <MultiSelect
                  name={name}
                  value={value}
                  options={assignToList}
                  placeholder="Please Select Assignees"
                  className="w-100 p-dropdown p-component p-inputwrapper"
                  onChange={(e) => onChange(e.value)}
                  display="chip"
                  optionLabel="label"
                />
              )}
            />
            <RequiredValidation errors={errors} field={`actions.${index}.contact_assignees`} />
          </div>
        )}
      </div>
    </>
  );
};

export default CreateDocument;
